import { RootState } from '@tabeeb/store'

export const getIsSnapshotInProgress = (state: RootState) => state.presentationToolbar.snapshotInProgress

export const getIsMuteVideoInProgress = (state: RootState) => state.presentationToolbar.muteVideoInProgress

export const getIsMuteAudioInProgress = (state: RootState) => state.presentationToolbar.muteAudioInProgress

export const getIsFlashInProgress = (state: RootState) => state.presentationToolbar.flashInProgress

export const getIsFlashTurnedOn = (state: RootState) => state.presentationToolbar.flashValue
